import { render, staticRenderFns } from "./ISearchOrganisationPicker.vue?vue&type=template&id=2c94997c"
import script from "./ISearchOrganisationPicker.vue?vue&type=script&lang=js"
export * from "./ISearchOrganisationPicker.vue?vue&type=script&lang=js"
import style0 from "./ISearchOrganisationPicker.vue?vue&type=style&index=0&id=2c94997c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports